import React, { useState, useEffect } from 'react';
import { DialogContent, Typography, Grid, makeStyles } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import { selectFirstComponentIfNeeded } from '../Reducers/Configurator/Actions';
import { useFirstComponentCheck } from '../Hooks/useFirstComponentCheck';

const useStyles = makeStyles(
  (theme) => ({
    gridList: {
      paddingLeft: theme.spacing(3),
    },
    section: {
      marginBottom: theme.spacing(1),
    },
    backDrop: {
      display: 'none',
    },
  }),
  {
    name: 'UsageHintDialog',
  }
);

export const UsageHintDialog = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const alreadyShown = sessionStorage.getItem('usageHintShown');
    if (!alreadyShown) {
      setOpen(true);
    }
  }, []);

  useFirstComponentCheck({ active: !open });

  const handleClick = () => {
    Services.configurator.loadInitialOptions();
    setOpen(false);
    sessionStorage.setItem('usageHintShown', 'true');
  };
  const classes = useStyles();
  const title = t('infoModal.title');
  const headline = t('infoModal.headline');
  const showHeadlineBelow = title !== headline;

  return (
    <CustomDialog
      open={open}
      onClose={handleClick}
      onCancel={handleClick}
      dialogTitle={title}
      BackdropProps={{
        classes: {
          root: classes.backDrop,
        },
      }}
    >
      <DialogContent>
        <Grid container direction="column" spacing={1}>
          {showHeadlineBelow && (
            <Grid item className={classes.section}>
              <Typography variant="body2">
                <b>{headline}</b>
              </Typography>
            </Grid>
          )}
          <Grid item className={classes.section}>
            <Typography variant="body2">{t('infoModal.text1')}</Typography>
          </Grid>
          <Grid item className={classes.section}>
            <Typography variant="body2">
              <b>{t('infoModal.instructions')}</b>
            </Typography>
          </Grid>

          <Grid item className={classes.section}>
            <Grid container direction="column" spacing={1} className={classes.gridList}>
              {[1, 2, 3, 4, 5, 6, 7].map((n) => (
                <Grid item key={n} className={classes.section}>
                  <Typography component="li" variant="body2">
                    <b>{t(`infoModal.step${n}Title`)}</b> {t(`infoModal.step${n}`)}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item className={classes.section}>
            <Typography variant="body2">{t('infoModal.text2')} </Typography>
          </Grid>
          <Grid item className={classes.section}>
            <MainButton variant="contained" size="medium" onClick={handleClick}>
              {t('infoModal.button')}
            </MainButton>
          </Grid>
        </Grid>
      </DialogContent>
    </CustomDialog>
  );
};
